<template>
  <div class="layout-menu-container">
    <div align="center">
      <img
        src="../../../public/images/sespa/brasao.svg"
        width="150"
        height="150"
        class="img-fluid img-thumbnail"
      />
    </div>
    <div align="center">
      <small>
        <b>
          <br />
          {{ user.user_name.toUpperCase() }}
          <br />
          {{ user.grupo }}
        </b>
      </small>
    </div>
    <hr />
    <AppSubmenu
      :items="model"
      class="layout-menu"
      :root="true"
      @menuitem-click="onMenuItemClick"
      @keydown="onKeyDown"
    />
  </div>
</template>

<script>
import AppSubmenu from "./AppSubmenu";

export default {
  props: {
    model: Array,
  },
  data() {
    return {};
  },
  methods: {
    onMenuItemClick(event) {
      this.$emit("menuitem-click", event);
    },
    onKeyDown(event) {
      const nodeElement = event.target;
      if (event.code === "Enter" || event.code === "Space") {
        nodeElement.click();
        event.preventDefault();
      }
    },
  },
  computed: {
    user: {
      get() {
        return this.$store.getters.getUserLogged;
      },
    },
  },
  components: {
    AppSubmenu: AppSubmenu,
  },
};
</script>